<template>
  <o-sales-view
    nav-bar-title="NMBS"
    title="Standaardbiljet"
    image="images/nmbs-header.jpg"
    :points="40"
    price="9,90"
    message="Optioneel staat hier extra uitleg over het product dat de gebruiker geselecteerd heeft."
    :tabs="tabs"
    next-link="/sales/train/nmbs/ticket/confirmation"
  >
    <o-section>
      <div class="c-trajectory">
        <div class="c-trajectory__start">Antwerpen-Centraal</div>
        <div class="c-trajectory__line"></div>
        <div class="c-trajectory__end">Gent-Sint-Pieters</div>
      </div>
    </o-section>
    <o-section>
      <o-text-input value="4 oktober 2018" icon="date" :readonly="true" />
    </o-section>
    <o-section>
      <o-text-input value="2de klas" icon="train" :readonly="true" />
    </o-section>
    <o-section>
      <o-text-input value="Enkel" icon="swap" :readonly="true" />
    </o-section>
  </o-sales-view>
</template>

<script>
import OSalesView from '@/components/OSalesView.vue'
export default {
  name: 'NMBS2',
  components: {
    OSalesView
  },
  data() {
    return {
      tabs: [
        {
          label: 'Standaardbiljet',
          isSelected: true
        },
        {
          label: 'Railpas'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.c-trajectory {
  align-items: center;
  display: flex;
}

.c-trajectory__start,
.c-trajectory__end {
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.c-trajectory__start {
  margin-right: 1.6rem;
}

.c-trajectory__end {
  margin-left: 1.6rem;
}

.c-trajectory__line {
  border-top: 0.2rem dashed $primary-color;
  border-top: 0.2rem dashed var(--primary-color);
  flex: 1 1 auto;
  height: 0rem;
  position: relative;

  &:before,
  &:after {
    background: #fff;
    border-radius: 0.4rem;
    box-shadow: 0 0 0 0.2rem $primary-color;
    box-shadow: 0 0 0 0.2rem var(--primary-color);
    content: '';
    height: 0.8rem;
    left: 0rem;
    position: absolute;
    top: -0.5rem;
    width: 0.8rem;
  }

  &:after {
    left: auto;
    right: 0rem;
  }
}
</style>
